module.exports = __webpack_public_path__ + "img/close-vesting-card.c2eb3849.svg";